import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Checkbox } from 'semantic-ui-react';
import _ from 'lodash';
import * as AppActions from '../../../actions';
import './ComparerTab.css';

const ExpandAllComparer = (props) => {
  const handleExpandAll = () => {
    const { actions, expandAll } = props;
    const url = window.location.href;
    const urlParts = url.split('#');
    if (urlParts[1]) {
      const params = urlParts[1].split('&');
      const showAllParam = _.find(
        params,
        (p) => p && p.indexOf('showAll=') !== -1
      );
      let newUrl = url;
      if (showAllParam) {
        const showAllStartingIndex = url.indexOf('&showAll=');
        const slicedUrl = url.slice(0, showAllStartingIndex);
        newUrl = `${slicedUrl}&showAll=${!expandAll}`;
      } else {
        newUrl = `${url}&showAll=${!expandAll}`;
      }
      window.location.replace(newUrl);
    }
    actions.expandAll();
  };
  return (
    <div>
      <strong>Expand all</strong>
      <Checkbox toggle onChange={handleExpandAll} checked={props.expandAll} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.user,
  expandAll: state.adPreview.expandAllAds
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExpandAllComparer);



// WEBPACK FOOTER //
// ./src/screens/Flipper/ParentSection/ExpandAllComparer.js